import React, { useContext, useState } from 'react';
import { Button, Icon } from 'semantic-ui-react';
import { HttpPostRequest } from '../../api/setFormData';
import { ReloadContext } from '../ReloadContext';

function RefreshPart({ shipmentId, merchandiseId, partRefreshFlag }) {
  const reloadContext = useContext(ReloadContext);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null); // 'success' | 'error' | null

  const handleRefresh = async () => {
    setLoading(true);
    setStatus(null); // Clear previous status

    try {
      const response = await HttpPostRequest({
        eventType: 'REFRESH_PART',
        eventTime: Date.now(),
        eventMessage: {
          shipmentId,
          merchandiseId,
        },
      });

      if (response.data.eventMessage?.code === 200) {
        reloadContext?.createEntrySummary && reloadContext.createEntrySummary()
        setStatus('success');
      } else {
        setStatus('error');
      }
    } catch (error) {
      console.error('Refresh failed', error);
      setStatus('error');
    } finally {
      setLoading(false);
      setTimeout(() => {
        setStatus(null); // Revert to refresh icon after 2 seconds
      }, 2000);
    }
  };

  if (partRefreshFlag !== "1") return null;

  let iconName = 'refresh';
  let iconColor;

  if (status === 'success') {
    iconName = 'check';
    iconColor = 'green';
  } else if (status === 'error') {
    iconName = 'exclamation circle';
    iconColor = 'red';
  }

  return (
    <div>
      <Button
        className='del-line-item-btn'
        basic
        color='blue'
        compact
        circular
        loading={loading}
        onClick={handleRefresh}
        disabled={loading}
      >
        <Icon name={iconName} color={iconColor} />
      </Button>
    </div>
  );
}

export default RefreshPart;
